export default __webpack_public_path__ + "49ad12c78de5a32ee2e39deaf0b1cbfa.svg";